import script from "./VariableSpending.vue?vue&type=script&setup=true&lang=js"
export * from "./VariableSpending.vue?vue&type=script&setup=true&lang=js"

import "./VariableSpending.vue?vue&type=style&index=0&id=cb31baae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb31baae"]])

export default __exports__